import React, {MutableRefObject} from "react";
import {css, Theme} from "@emotion/react";

import {mb, w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {SelectedFormValuesType} from "../../../offer/list/components/OfferListNotificationsSubscriptionModal";
import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_query";
import {searchFormFields as propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams, SearchTab} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType | SelectedFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    stopFetchingAfterRegionList?: boolean;
    disablePlaceFetch?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    showOnlyRegions?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        stopFetchingAfterRegionList = false,
        disablePlaceFetch = false,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        showOnlyRegions,
        disableMultiRegion,
        isDropdownOpen
    } = props;
    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div css={[searchAutocompleteWrapper, showSelectedUnderInput && w100]}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input) => formProps.fetchAllSearchLists(input, {country: searchCountry, stopFetchingAfterRegionList, disablePlaceFetch})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                renderDropdownList={(props) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={props.onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={showOnlyRegions ? [] : props.offers}
                        places={showOnlyRegions ? [] : props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = (theme: Theme) => css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0;
        max-height: 100%;
        width: 100%;
        ${mb(2)};
    }
`;
import React, {MutableRefObject} from "react";
import {css, Theme} from "@emotion/react";

import {mb, w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {SelectedFormValuesType} from "../../../offer/list/components/OfferListNotificationsSubscriptionModal";
import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_query";
import {searchFormFields as propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams, SearchTab} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType | SelectedFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    stopFetchingAfterRegionList?: boolean;
    disablePlaceFetch?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    showOnlyRegions?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        stopFetchingAfterRegionList = false,
        disablePlaceFetch = false,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        showOnlyRegions,
        disableMultiRegion,
        isDropdownOpen
    } = props;
    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div css={[searchAutocompleteWrapper, showSelectedUnderInput && w100]}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input) => formProps.fetchAllSearchLists(input, {country: searchCountry, stopFetchingAfterRegionList, disablePlaceFetch})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                renderDropdownList={(props) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={props.onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={showOnlyRegions ? [] : props.offers}
                        places={showOnlyRegions ? [] : props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = (theme: Theme) => css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0;
        max-height: 100%;
        width: 100%;
        ${mb(2)};
    }
`;
